require('dotenv');
const axios = require('axios').default;

let AcceptAwardOfferApi = {

    endpoint : "AcceptAwardOffer/",

    async update(accountId) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint + accountId;

        const response = await axios.put(URL, {}, { withCredentials: true });
        return response.data;
    }
}



export { AcceptAwardOfferApi }